import { useEffect, useState } from 'react';
import { useProductMasterPage } from '../services/api/domains/products/hooks';
import { ProductMasterItem } from '../services/api/domains/products/types';

const ProductMasterReview: React.FC = () => {
  const [search, setSearch] = useState('');
  const [sortConfig] = useState<{
    key: string;
    direction: 'asc' | 'desc';
  } | null>(null);
  const [editingProduct] = useState<{
    id: number;
    name: string;
  } | null>(null);

  const productMasterManager = useProductMasterPage();

  // const handleEdit = async (id: number, oldName: string) => {
  //   const newName = prompt('Edit Product Name:', oldName);
  //   if (!newName || newName === oldName) return;

  //   try {
  //     setEditingProduct({ id, name: newName });
  //     await productMasterManager.update(id).mutate({
  //       product_cas_name: newName,
  //       product_id: id,
  //     });
  //     setEditingProduct(null);
  //   } catch (error) {
  //     console.error('❌ Edit failed:', error);
  //     alert('Update failed. Please try again.');
  //     setEditingProduct(null);
  //   }
  // };

  // const handleSort = (key: string) => {
  //   let direction: 'asc' | 'desc' = 'asc';
  //   if (sortConfig?.key === key && sortConfig.direction === 'asc') {
  //     direction = 'desc';
  //   }
  //   setSortConfig({ key, direction });
  // };

  useEffect(() => {
    // TODO: Implement UI to show editing state
    console.log('✏️ Currently editing product:', editingProduct);
  }, [editingProduct]);

  const data = productMasterManager.data;
  const error = productMasterManager.error?.message || null;

  const sorted = [...data].sort((a, b) => {
    if (!sortConfig) return 0;
    const key = sortConfig.key as keyof ProductMasterItem;
    const aVal = a[key]?.toString().toLowerCase() || '';
    const bVal = b[key]?.toString().toLowerCase() || '';
    return sortConfig.direction === 'asc'
      ? aVal.localeCompare(bVal)
      : bVal.localeCompare(aVal);
  });

  const filtered = sorted.filter(item =>
    (item.product_cas_name || '').toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div style={styles.containerStyle}>
      {error && (
        <div style={styles.errorStyle} role="alert">
          <span style={styles.errorTextStyle}>{error}</span>
        </div>
      )}
      {productMasterManager.isLoading && (
        <div style={styles.loadingContainerStyle}>
          <span style={styles.loadingTextStyle}>
            Loading product master data...
          </span>
        </div>
      )}
      <p style={styles.countStyle}>
        Showing {filtered.length} Product{filtered.length !== 1 ? 's' : ''}
      </p>

      <input
        style={styles.inputStyle}
        placeholder="Search by Product Name"
        value={search}
        onChange={e => setSearch(e.target.value)}
      />

      {/* <LgmDataTable
        data={filtered}
        columns={[
          { label: 'Product Name', key: 'product_cas_name' },
          {
            label: 'Actions',
            key: 'actions',
            render: row => (
              <button
                style={styles.editButtonStyle}
                onClick={() =>
                  handleEdit(
                    row.product_id && typeof row.product_id === 'number'
                      ? row.product_id
                      : -1,
                    row.product_cas_name && typeof row.product_cas_name === 'string'
                      ? row.product_cas_name
                      : ''
                  )
                }>
                Edit
              </button>
            ),
          },
        ]}
        sortConfig={sortConfig}
        onSort={handleSort}
      /> */}
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  containerStyle: {
    padding: '2rem', // p-8
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem', // space-y-6
    fontFamily: 'inherit', // font-lgm
  } as React.CSSProperties,
  errorStyle: {
    backgroundColor: '#fecaca', // bg-red-100
    border: '1px solid #f87171', // border-red-400
    color: '#b91c1c', // text-red-700
    padding: '0.75rem 1rem', // px-4 py-3
    borderRadius: '0.25rem', // rounded
    position: 'relative',
  } as React.CSSProperties,
  errorTextStyle: {
    display: 'block', // block sm:inline - simplified to block
  } as React.CSSProperties,
  loadingContainerStyle: {
    textAlign: 'center',
    padding: '1rem 0', // py-4
  } as React.CSSProperties,
  loadingTextStyle: {
    color: '#4b5563', // text-gray-600
  } as React.CSSProperties,
  countStyle: {
    color: '#4b5563', // text-gray-600
  } as React.CSSProperties,
  inputStyle: {
    width: '100%', // w-full on mobile, md:w-1/2 on medium screens - simplified to 100%
    maxWidth: '50%', // approximating md:w-1/2
    border: '1px solid #e5e7eb',
    borderRadius: '0.25rem', // rounded
    padding: '0.5rem 0.75rem', // px-3 py-2
  } as React.CSSProperties,
  editButtonStyle: {
    backgroundColor: '#2563eb', // bg-blue-600
    color: 'white',
    padding: '0.25rem 0.75rem', // px-3 py-1
    borderRadius: '0.25rem', // rounded
    marginRight: '0.5rem', // mr-2
    border: 'none',
    cursor: 'pointer',
  } as React.CSSProperties,
};

export default ProductMasterReview;
